<template>
  <div>
    <div v-if="showTitle" class="mb-4">
      <h3 class="font-weight-bolder">{{ $t('hd.objects.channel') }} {{channelId}}</h3>
      <h5 class="font-weight-normal">{{$t('hd.channels.'+channelId + '.name') }}</h5>
    </div>
    <div v-if="content" class="grid grid-cols-1 gap-5">
      <h1 v-if="isRelatedToggle" class="keynote-title mb-3">
        {{showPersonal && content.keynote_personal ? content.keynote_personal : content.keynote }}
      </h1>

      <audio-player v-if="!loading && content.audio" :key="channelId" :file-url="content.audio" />

      <mbg-accordion-item
          v-if="content.description"
          :reverse-background="reverseBackground"
          :text="showPersonal ? $t('charts.properties.analysis') : $t('charts.properties.overview')"
          :content="showPersonal ? content.description_personal : content.description"
          class="mt-4"/>

      <mbg-accordion-item v-if="content.circuitry" text="Circuitry" :reverse-background="reverseBackground"
                          :content="content.circuitry" />
    </div>
  </div>
</template>

<script>
import AudioPlayer from "../../../structure/AudioPlayer";
import {isCompositeDocumentType} from "../../../../helpers/docTypes";
import MbgAccordionItem from "../../../elements/MbgAccordionItem.vue";
export default{
  props:{
    channelId: Number,
    loading: Boolean,
    showTitle:{
      type: Boolean,
      default: false
    },
    isRelatedToggle: Boolean,
    reverseBackground: Boolean
  },
  components:{MbgAccordionItem, AudioPlayer},
  data(){
    return{
      content: null,
      tab: 0,
    }
  },
  computed:{
    showPersonal(){
      return !isCompositeDocumentType(this.$store.state.charts.chart.meta.type);
    }
  },
  watch:{
    channelId(val){
      if(val) this.getContent();
    }
  },
  created(){
    this.getContent();
  },
  methods:{
    getContent(){
      this.$emit('loading', true);
      this.axios.get(`/content/${this.$route.params.chartId}/channels/${this.channelId}`).then(res=>{
        this.content = res.data;
        if(this.showPersonal) this.$emit('keynoteSet', this.content.keynote_personal);
        else this.$emit('keynoteSet', this.content.keynote);
      }).catch(e=>{
        console.log(e);
      }).finally(()=>{
        this.$emit('loading', false);
      })
    }
  }

}
</script>